import React from 'react';
import { withRouter } from 'react-router-dom';
import { Navbar, Nav, Form, Button } from 'react-bootstrap';
import { NavLink } from 'react-router-dom'
import { Link } from 'react-router-dom';
import '../scss/custom.scss';
import './Navbar.css';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { ROOT_URL, UPDATE_DATE_APPLICATION, UPDATE_DATE_DATA } from '../actions';
import Axios from 'axios';

class Navigation extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
        };
    }

    logoutUser() {
        localStorage.clear();
    }

    DashboardLink() {
        Axios.get(ROOT_URL + '/switch-dashboard ', {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'mode': 'cors',
                "Content-Type": "application/json",
                'Access-Control-Allow-Origin': '*',
            },
        }).then((res) => {
            console.log(res)
            if (res.status == 200) {
                console.log(res.data.redirectUrl)
                window.location = (res.data.redirectUrl);
            } else {
            }
        })
    }


    VideoLink() {

        window.open('https://imark-plumbing.tredence.com/imark-demo-link/login?token=');

    }


    render() {
        return (
            <header >
                <Navbar className="mb-3 shadow-sm bd-navbar" >
                    <Navbar.Brand >
                    {/* <h3 style= {{marginLeft: '50px',"font-family": 'Fantsy', color: 'rgb(255, 127, 14)' , 'font-size':' xx-large' ,'font-variant': 'proportional-nums','text-decoration': 'underline','textDecorationStyle': "double"}} >Rebate.ai</h3> */}
                                              <Link to="/" className="btn btn-link"  > <img height="35" src={process.env.PUBLIC_URL + '/IMARK Logo.png'} alt="img  " />
                        </Link>
                    </Navbar.Brand>
                    <Navbar.Text>{this.props.groupId}</Navbar.Text>
                    <Nav className="navbar-nav mr-auto">
                        <NavLink to="/Corporate/Overview" className="nav-link" activeStyle={{
                            textDecorationLine: 'underline',
                            textDecorationColor: "#2d75c3",
                            textDecorationStyle: "double",
                        }} activeClassName="active">Corporate Overview</NavLink>
                        <NavLink to="/Corporate/RebateData" className="nav-link " activeStyle={{
                            textDecorationLine: 'underline',
                            textDecorationColor: "#2d75c3",
                            textDecorationStyle: "double",
                        }} activeClassName="active">Supplier Data</NavLink>
                        <NavLink to="/Corporate/Opportunities" className="nav-link" activeStyle={{
                            textDecorationLine: 'underline',
                            textDecorationColor: "#2d75c3",
                            textDecorationStyle: "double",
                        }} activeClassName="active">Opportunity</NavLink>
                        <NavLink to="/Corporate/Feedback" className="nav-link" activeStyle={{
                            textDecorationLine: 'underline',
                            textDecorationColor: "#2d75c3",
                            textDecorationStyle: "double",
                        }} activeClassName="active">Feedback</NavLink>
                        <NavLink to="/Corporate/ConversionOpportunity" className="nav-link" activeStyle={{
                            textDecorationLine: 'underline',
                            textDecorationColor: "#2d75c3",
                            textDecorationStyle: "double",
                        }} activeClassName="active">Conversion Opportunity</NavLink>
                        <NavLink to="/Corporate/FBIRebate" className="nav-link" activeStyle={{
                            textDecorationLine: 'underline',
                            textDecorationColor: "#2d75c3",
                            textDecorationStyle: "double",
                        }} activeClassName="active">Supplier FBI Rebate</NavLink>
                        <NavLink to="/Corporate/Compliance" className="nav-link" activeStyle={{
                            textDecorationLine: 'underline',
                            textDecorationColor: "#2d75c3",
                            textDecorationStyle: "double",
                        }} activeClassName="active">Compliance</NavLink>
                    </Nav>
                    {process.env.PUBLIC_URL === '/imarkdemo' ? (
                        <Navbar.Text className="mr-3" style={{ "fontSize": "0.8em" }}>
                            <p className="my-0">Data Updated On: <strong>{UPDATE_DATE_DATA}</strong></p>
                            <p className="my-0">Application Updated On: <strong>{UPDATE_DATE_APPLICATION}</strong></p>
                        </Navbar.Text>
                    ) : ''}
                    <Form inline>
                        <OverlayTrigger overlay={(<Tooltip id="callModal">Dashboard Link</Tooltip>)}
                            popperConfig={{ modifiers: { preventOverflow: { boundariesElement: 'viewport' } } }} placement="down">
                            <Button variant="outline-primary" target="_blank" onClick={(e) => { this.DashboardLink() }}>
                                {process.env.PUBLIC_URL === '/imarkdemo' ? 'Go back to Dashboard' : 'Demo Dashboard'}
                            </Button>
                        </OverlayTrigger>
                        <OverlayTrigger overlay={(<Tooltip id="callModal"> Contact Us</Tooltip>)} popperConfig={{ modifiers: { preventOverflow: { boundariesElement: 'viewport' } } }} placement="down">
                            <a href="mailto:imarkplumbing.helpdesk@tredence.com, imark@tredence.com" className="btn btn-link" data-placement="bottom" data-container="body"><i className="fas fa-envelope"></i></a>
                        </OverlayTrigger>
                        <OverlayTrigger overlay={(<Tooltip id="callModal"> Logout</Tooltip>)} popperConfig={{ modifiers: { preventOverflow: { boundariesElement: 'viewport' } } }} placement="down">
                            <Link to="/logout" onClick={(e) => { this.logoutUser() }} className="btn btn-link" ><i className="fas fa-power-off"></i></Link>
                        </OverlayTrigger>
                    </Form>
                </Navbar>
            </header>

        );
    }
}
export default withRouter(Navigation);